export default {
  snackbar: {
    message: undefined,
    active: undefined,
  },
};



// WEBPACK FOOTER //
// ./src/store/app/state.js